import { Graphics, Ticker, LINE_CAP } from "pixi.js";
import { DrawFrmApp } from "../drawfrm/DrawFrmApp";
import { Scene } from "../drawfrm/Scene";

const RADIUS = 18;
const LINE_WIDTH = 2.5;
const COLOR = 0x222222;
const ROTATION_SPEED = 0.08;
const ARC_SPAN = Math.PI * 1.35;

export class LoadingScene implements Scene {
    private graphic: Graphics | null = null;
    private ticker: Ticker | null = null;
    private draw: DrawFrmApp | null = null;
    private elapsed = 0;

    setup(draw: DrawFrmApp) {
        this.draw = draw;

        const g = new Graphics();
        g.zIndex = 9999;
        draw.pixi.stage.addChild(g);
        this.graphic = g;

        const ticker = new Ticker();
        ticker.add(this.tick);
        ticker.start();
        this.ticker = ticker;
    }

    private tick = (delta: number) => {
        this.elapsed += delta;

        const draw = this.draw;
        const g = this.graphic;
        if (!draw || !g) return;

        const { width, height } = draw.pixi.renderer.screen;
        const cx = width / 2;
        const cy = height / 2;

        const start = this.elapsed * ROTATION_SPEED;

        g.clear();
        g.lineStyle({ width: LINE_WIDTH, color: COLOR, alpha: 0.15, cap: LINE_CAP.ROUND });
        g.drawCircle(cx, cy, RADIUS);
        g.lineStyle({ width: LINE_WIDTH, color: COLOR, alpha: 0.9, cap: LINE_CAP.ROUND });
        g.arc(cx, cy, RADIUS, start, start + ARC_SPAN);
    };

    // a centered overlay spinner positioned from the live screen size each tick,
    // so it has no flex layout to re-apply.
    applyLayout() {}

    dispose() {
        if (this.ticker) {
            this.ticker.remove(this.tick);
            this.ticker.destroy();
            this.ticker = null;
        }
        if (this.graphic) {
            this.graphic.destroy();
            this.graphic = null;
        }
        this.draw = null;
    }
}
